import React, {Component} from 'react';
import {connect} from 'react-redux';
import {formatUtcDateToLocalDateFormat, convertTimeCreditToPcBangPoint} from '../../../../util/timeUtils';
import Paginate from '../../../Common/Paginate';
import {fetchPaymentHistoryForCurrentUser, PURCHASE_STATES} from '../../../../actions/usageStatus.actions';
import moment from 'moment-timezone';
import {USER_READABLE_PAYMENT_TYPES} from '../../../../constants/purchase.constants';
import commaNumber from 'comma-number';
import {Table} from '../../../Common/PageComponents';

const stateToProps = state => {
  return {
    paymentRecords: state.usageStatus.paymentHistory.content,
    pageNumber: state.usageStatus.paymentHistory.pageNumber,
    totalItemCount: state.usageStatus.paymentHistory.totalItemCount,
    startDate: state.usageStatus.paymentHistory.startDate,
    endDate: state.usageStatus.paymentHistory.endDate,
  };
};

class PaymentHistoryList extends Component {
  _movePage(pageNumber) {
    let endDate = this.props.endDate;
    let revisedEndDate = moment(endDate, 'YYYY-MM-DD')
      .add(1, 'days')
      .format('YYYY-MM-DD');

    this.props.dispatch(fetchPaymentHistoryForCurrentUser(this.props.startDate, revisedEndDate, pageNumber));
  }

  _renderPayments(paymentRecords) {
    if (paymentRecords && paymentRecords.length > 0) {
      return paymentRecords.map((record, index) => (
        <tr key={index}>
          <td>{formatUtcDateToLocalDateFormat(record.paidAt)}</td>
          <td>{commaNumber(record.price)} 원</td>
          <td>{convertTimeCreditToPcBangPoint(record.timeCredit)}</td>
          <td>{USER_READABLE_PAYMENT_TYPES[record.paymentType]}</td>
          <td>{PURCHASE_STATES[record.state]}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="5">결제내역이 없습니다.</td>
      </tr>
    );
  }

  render() {
    return (
      <div>
        <Table>
          <colgroup>
            <col style={{width: '90px'}} />
            <col style={{width: '156px'}} />
            <col style={{width: '112px'}} />
            <col style={{width: '115px'}} />
            <col style={{width: '90px'}} />
          </colgroup>
          <thead>
            <tr>
              <th>결제일</th>
              <th>결제 금액</th>
              <th>충전 포인트</th>
              <th className="end">결제 방법</th>
              <th className="end">상태</th>
            </tr>
          </thead>
          <tbody>{this._renderPayments(this.props.paymentRecords)}</tbody>
        </Table>
        <Paginate
          currentPage={this.props.pageNumber}
          totalItemCount={this.props.totalItemCount}
          onChange={this._movePage.bind(this)}
        />
      </div>
    );
  }
}

export default connect(stateToProps)(PaymentHistoryList);
